const wishlistJs = document.getElementById('wishlistcommonscript');
const wishlistConfigJs = document.getElementById('vtSettings');
const parseWishlistConfigJs = JSON.parse(wishlistConfigJs.textContent);
const vtnShopId = parseWishlistConfigJs.config.shopId;
const vtnCustomerId = parseWishlistConfigJs.config.customerId;
const vtnShopDomain = parseWishlistConfigJs.config.shopDomain;
const vtnLoginCondition = parseWishlistConfigJs.config.login;
const vtnVersion = parseWishlistConfigJs.config.version;
const vtnStorefrontAccessToken = parseWishlistConfigJs.config.storefrontAccessToken;
const wishlistPageUrl = parseWishlistConfigJs.settings.wishlistPageUrl;
const wishlistMode = parseWishlistConfigJs.config.mode;
const vtnSHOPIFY_GRAPHQL_API_ENDPOINT = '/api/2023-01/graphql.json';
const vtnEndpoint = `${vtnSHOPIFY_GRAPHQL_API_ENDPOINT}`;
const vtnCache = 'force-cache';
let vtnApiInProgress = false;

window.wishlistInsertAfter = function (newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
};

if (typeof window.vtWishlist === 'undefined') {
  window.vtWishlist = {};
}

if (typeof window.vtWishlist.generalSettings === 'undefined') {
  window.vtWishlist.generalSettings = {};
}

window.vtWishlist.generalSettings = {
  is_login_required: vtnLoginCondition === 'login-required' ? true : false,
  hide_wishlistPage: vtnLoginCondition === 'login-required-to-view-list' ? true : false
}

function loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  script.onload = callback;
  document.head.appendChild(script);
}

if (!window.vtScript) {
  console.error("VT Script is not define");
}
window.vtLoadSingleJs = (script) => {
  loadScript(script, () => {
    console.log(script, " loaded");
  })
}
window.vtScript.forEach((script, index) => {
  loadScript(script, function () {
    if ((index + 1) === vtScript.length) {
      window.vtScriptLoaded = true;
    }
  });
})

//logout check
document.addEventListener("click", function (event) {
  if (
    event.target.tagName === "A" &&
    event.target.getAttribute("href") &&
    event.target.getAttribute("href").includes("/account/logout")
  ) {
    event.preventDefault();
    if (localStorage.getItem("wishlist") !== null) {
      localStorage.removeItem("wishlist");
    }
    if (localStorage.getItem("vtWishlistDataSync") !== null) {
      localStorage.removeItem("vtWishlistDataSync");
    }
    if (localStorage.getItem("guest_wishlist_id") !== null) {
      localStorage.removeItem("guest_wishlist_id");
    }
    if (localStorage.getItem("wishlist_pending") !== null) {
      localStorage.removeItem("wishlist_pending");
    }
    window.location.href = "/account/logout";
  }
});

// set a localStorge to check if the data has been sync in or not
function customerDataSyncCheck(dataSynchCheck) {
  localStorage.setItem("vtWishlistDataSync", dataSynchCheck);
}
//check if customerId exists
function checkCustomerExists() {
  if (typeof vtnCustomerId !== 'undefined' && vtnCustomerId !== '' && vtnCustomerId !== null) {
    return true;
  } else {
    return false;
  }
}

// error log function
window.vtLogErrors = logErrors;
function logErrors(dataArray, note){
  let guestID = null;
  let customerID = null;
  if (localStorage.getItem("guest_wishlist_id") !== null) {
     guestID = localStorage.getItem("guest_wishlist_id");
  }
  if(checkCustomerExists()){
    customerID = vtnCustomerId;
  }

  fetch("/apps/wish/wishlist-logs", {
    method: "POST",
    body: JSON.stringify({
      data: {
        shopId: 'gid://shopify/Shop/' + vtnShopId,
        customerId: customerID,
        guest_id: guestID,
        localStorage: dataArray,
        storefrontAccessToken : vtnStorefrontAccessToken
      },
      location: window.location.pathname,
      note: note
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    }
  })
  .then((response) => response.json())
  .catch((error) => {
    console.log(error)
  });
}

//convertGuestToCustomer 
function convertGuestToCustomer() {
  let guestID = localStorage.getItem("guest_wishlist_id");
  let localStoredData = JSON.parse(localStorage.getItem("wishlist"));
  fetch("/apps/wish/guest-api", {
    method: "POST",
    body: JSON.stringify({
      shopId: 'gid://shopify/Shop/' + vtnShopId,
      guestId: parseInt(guestID),
      customerId: parseInt(vtnCustomerId),
      productsArray: localStoredData
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    }
  })
    .then((response) => response.json())
    .catch((error) => {
      console.log(error);
      let dataArray = localStoredData;
      let note = "Convert Guest to Customer API issue"
      logErrors(dataArray, note)
    });
   // .then((json) => console.log(json));
  localStorage.removeItem("guest_wishlist_id");
}

// update data if customer is logged in but has not yet opened accounts page (account create case)
function customerLoginCheck() {
  if(checkCustomerExists()){
    checkUpdatePending();
    let vtWishlistDataSyncElement = localStorage.getItem('vtWishlistDataSync');
    if (vtWishlistDataSyncElement === null && vtWishlistDataSyncElement !== 'Data synched!') {
      retreiveDataFromAPI();
      if (wishlistMode && vtnLoginCondition == 'login-required') {
        reUpdateStatus()
      }
      customerDataSyncCheck('Data synched!');
    }
  }
}

customerLoginCheck();

// Tracking
function dispatchvtWishCustomEvent(eventName, eventData) {
  const customEvent = new CustomEvent(eventName, {
    detail: eventData,
    bubbles: true, // Allows the event to bubble up through the DOM
  });

  // Dispatch the custom event on a target element (or document if not specified)
  document.dispatchEvent(customEvent);
}

window.vtGetWishlistData = getLocalStorageData;
function getLocalStorageData() {
  return localStorage.getItem("wishlist");
}

function setLocalStorageData(newData) {
  localStorage.setItem('wishlist', JSON.stringify(newData));
}

async function retreiveDataFromAPI() {
  let localwishlistData = getLocalStorageData();
  let wishlistData = JSON.parse(localwishlistData);
  try {
    let response = await fetch("/apps/wish/wishlist-api?shopId=" + vtnShopId + "&customerId=" + vtnCustomerId);
    let myFetchedAppData = await response.json();

    if (localwishlistData !== null && myFetchedAppData !== null) {
      if (wishlistData.length > 0 && myFetchedAppData.length > 0) {
        const areArraysEqual = arraysAreEqual(wishlistData, myFetchedAppData);
        // compare and merge values 
        if (!areArraysEqual) {
          const mergedArray = [...wishlistData, ...myFetchedAppData].filter((value, index, self) =>
            index === self.findIndex(item => item.wpdvi === value.wpdvi)
          );

          setLocalStorageData(mergedArray)
          sendData(mergedArray);
          updateCount();
        }
      } else if (wishlistData.length < 1 && myFetchedAppData.length > 0) {
        setLocalStorageData(myFetchedAppData);
        updateCount();
      } else if (wishlistData.length > 0 && myFetchedAppData.length < 1) {
        sendData(wishlistData);
        updateCount();
      }

    } else if (localwishlistData !== null && myFetchedAppData === null) {
      if (wishlistData.length > 0) {
        sendData(wishlistData);
        updateCount();
      }
    } else if (localwishlistData === null && myFetchedAppData !== null) {
      if (myFetchedAppData.length > 0) {
        setLocalStorageData(myFetchedAppData);
        updateCount();
      }
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    let dataArray = null;
    let note = "Retrieve data API issue"
      logErrors(dataArray, note);
  }
}

function checkUpdatePending() {
  if (localStorage.getItem("wishlist_pending") !== null) {
    let previousWishlist = localStorage.getItem("wishlist");
    let previousWishlistParsed = JSON.parse(previousWishlist);
    let pendingWishlist = localStorage.getItem("wishlist_pending");
    let pendingWishlistParsed = JSON.parse(pendingWishlist);
    if (previousWishlist !== null && previousWishlistParsed.length > 0) {
      let arePrevArraysEqual = arraysAreEqual(previousWishlistParsed, pendingWishlistParsed);
      // compare and merge values 
      if (!arePrevArraysEqual) {
        let mergedPrevArray = [...previousWishlistParsed, ...pendingWishlistParsed].filter((value, index, self) =>
          index === self.findIndex(item => item.wpdvi === value.wpdvi)
        );
        setLocalStorageData(mergedPrevArray);
        localStorage.removeItem("wishlist_pending");
      }
    } else {
      setLocalStorageData(pendingWishlistParsed);
      localStorage.removeItem("wishlist_pending");
    }
  }
}

// recheck and update data on login
if (window.location.href.indexOf('/account') > -1) {
  if(checkCustomerExists()){
    checkUpdatePending();
    retreiveDataFromAPI();
    if (wishlistMode && vtnLoginCondition == 'login-required') {
      reUpdateStatus()
    }
    let vtWishlistDataSyncElement = localStorage.getItem('vtWishlistDataSync');
    if (vtWishlistDataSyncElement === null && vtWishlistDataSyncElement !== 'Data synched!') {
      customerDataSyncCheck('Data synched!');
    }
  }
}

// add return path in login/register based on guest not allowed in all plans (wishlist pending)
function returnTo() {
  let vtnCurrentUrl = window.location.href;
  let returnURL = localStorage.getItem('wishlist_return');
  if ((vtnCurrentUrl.indexOf('/account/login') > -1) || (vtnCurrentUrl.indexOf('/account/register') > -1)) {
    if (localStorage.getItem('wishlist_return') !== null) {
      let create_customer = document.querySelector('#create_customer');
      let customer_login = document.querySelector('#customer_login');
      let hiddenInput = document.createElement('input');
      if (create_customer) {
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', 'checkout_url');
        hiddenInput.setAttribute('value', returnURL);
        create_customer.appendChild(hiddenInput);
      }
      if (customer_login) {
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', 'return_to');
        hiddenInput.setAttribute('value', returnURL);
        customer_login.appendChild(hiddenInput);
      }
    }
  }
  if (vtnCurrentUrl === returnURL) {
    localStorage.removeItem('wishlist_return');
  }

}
returnTo();

// get guest id and then update data 
async function guestLogic() {
  if (!(typeof vtnCustomerId !== 'undefined' && vtnCustomerId !== '' && vtnCustomerId !== null)) {
    if (wishlistMode && vtnLoginCondition == 'login-optional') {
      if (localStorage.getItem("guest_wishlist_id") === null) {
        if (!vtnApiInProgress) {
          vtnApiInProgress = true; 
          try {
            let guestResponse = await fetch("/apps/wish/guest-api?shopId=" + vtnShopId);
            let guestData = await guestResponse.json();
            // console.log('guest Id',guestData);
            localStorage.setItem('guest_wishlist_id', guestData);
            localStorage.removeItem('vtWishlistDataSync');
          } catch (error) {
            console.error('Error fetching data:', error);
            let dataArray = null;
            let note = "Fetch Guest Id API issue"
            logErrors(dataArray, note);
          } finally {
            vtnApiInProgress = false;
          }
          let guestID = localStorage.getItem("guest_wishlist_id");
          let wishlistLocal = localStorage.getItem("wishlist");
          if (wishlistLocal !== null) {
            let localStoredPendingData = JSON.parse(wishlistLocal);
            fetch("/apps/wish/guest-api", {
              method: "POST",
              body: JSON.stringify({
                shopId: 'gid://shopify/Shop/' + vtnShopId,
                guestId: parseInt(guestID),
                customerId: null,
                productsArray: localStoredPendingData
              }),
              headers: {
                "Content-type": "application/json; charset=UTF-8"
              }
            })
              .then((response) => response.json())
              .catch((error) => {
                console.log(error);
                let dataArray = localStoredPendingData;
                let note = "Send Guest data to DB API issue"
                logErrors(dataArray, note);
              });
            // .then((json) => console.log(json));
          }
        }
      }
    }
  }
}

//reupdate button status in guest cases
function reUpdateStatus() {
  setTimeout(function () {
    let wishlistData = JSON.parse(localStorage.getItem("wishlist"));
    let wishlistCollCards = document.querySelectorAll('wishlist-collection-button');
    wishlistCollCards.forEach(function (card) {
      let cardId = card.getAttribute('data-product-id');
      wishlistData.some(element => {
        if (element.wpdi === cardId) {
          if (card.querySelector('.add-wishlist').style.display != 'none') {
            card.querySelector('.add-wishlist').style.display = 'none';
          }
          if (card.querySelector('.remove-wishlist').style.display != 'flex') {
            card.querySelector('.remove-wishlist').style.display = 'flex';
          }
        }
      })
    })
  }, 2000)
}

//remove the local data which is not having product id and variant id
function filterLocal() {
  let initialLocalData = localStorage.getItem("wishlist");
  if (!initialLocalData) {
    return
  }
  let storedData = JSON.parse(initialLocalData);
  storedData = storedData.filter(item => item.wpdi && item.wpdvi);
  localStorage.setItem('wishlist', JSON.stringify(storedData));
}

filterLocal();

//Send data to API
function sendData(data) {
  if(checkCustomerExists()){
    if (localStorage.getItem("guest_wishlist_id") === null) {
      fetch("/apps/wish/wishlist-api", {
        method: "POST",
        body: JSON.stringify({
          shopId: 'gid://shopify/Shop/' + vtnShopId,
          customerId: parseInt(vtnCustomerId),
          productsArray: data
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      })
        .then((response) => response.json())
        .catch((error) => {
          console.log(error);
          let dataArray = data;
          let note = "Send Customer data to DB API issue"
          logErrors(dataArray, note);
        });
      // .then((json) => console.log(json));
    } else {
      convertGuestToCustomer();
    }
  } else {
    if (localStorage.getItem("guest_wishlist_id") !== null) {
      let guestID = localStorage.getItem("guest_wishlist_id");
      let wishlistLocal = localStorage.getItem("wishlist");
      if (wishlistLocal !== null) {
        let localStoredPendingData = JSON.parse(wishlistLocal);
        fetch("/apps/wish/guest-api", {
          method: "POST",
          body: JSON.stringify({
            shopId: 'gid://shopify/Shop/' + vtnShopId,
            guestId: parseInt(guestID),
            customerId: null,
            productsArray: localStoredPendingData
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8"
          }
        })
          .then((response) => response.json())
          .catch((error) => {
            console.log(error);
            let dataArray = localStoredPendingData;
            let note = "Send Guest Pending data to DB API issue"
            logErrors(dataArray, note);
          });
        //  .then((json) => console.log(json));
      }
    }
  }
}

window.vtUpdateCount = updateCount;
function updateCount(){
  let wishlistLocal = localStorage.getItem("wishlist");
  let wishlistLocalCount = 0;
  if (wishlistLocal !== null) {
   wishlistLocalCount = JSON.parse(wishlistLocal).length;
  }
  let wishlistCountElements = document.querySelectorAll('wishlist-count');
  if(wishlistCountElements){
       wishlistCountElements.forEach(function (wishlistCountElement) {
           wishlistCountElement.querySelector('span').textContent = wishlistLocalCount;
           if(wishlistLocalCount == 0){
             wishlistCountElement.querySelector('span').setAttribute('data-value', '0');
           }else{
             wishlistCountElement.querySelector('span').removeAttribute('data-value');
           }
             if(wishlistPageUrl !== ''){
               wishlistCountElement.outerHTML = `<a href="${wishlistPageUrl}">${wishlistCountElement.outerHTML}</a>`;
             }
       })
   }
}
updateCount();

//custom global add to wishlist
window.vtAddToWishlistTrigger = vtAddToWishlist;
function vtAddToWishlist(product){
  let wishlistData;
  let add = true;
  if (localStorage.getItem("wishlist") === null) {
    wishlistData = [];
  } else {
    wishlistData = JSON.parse(localStorage.getItem("wishlist"));
    wishlistData.some(element => { if (element.wpdvi === product.wpdvi) { add = false } })
  }
  if (add) {
    wishlistData.push(product);
    localStorage.setItem('wishlist', JSON.stringify(wishlistData));
    guestLogic();
    sendData(wishlistData);
    updateCount();
    dispatchvtWishCustomEvent('eventVtAddToWishlist', {
      wpdi: product.wpdi,
      wpdvi: product.wpdvi,
      targetFrom: 'custom'
    });
  }
}

function addToWishlistCommon(target, product, add, parentPage) {
  let wishlistData;
  if (localStorage.getItem("wishlist") === null) {
    wishlistData = [];

    let loginOptionalMessageElement = target.parentNode.querySelector('.login-optional-message');
    if (loginOptionalMessageElement && loginOptionalMessageElement.textContent !== '' && parentPage == 'product') {
      if (typeof vtnCustomerId === 'undefined' || vtnCustomerId === '' || vtnCustomerId === null) {
        loginOptionalMessageElement.style.display = 'block';
        setTimeout(() => {
          loginOptionalMessageElement.style.display = 'none';
        }, 30000);
      }
    }
  } else {
    wishlistData = JSON.parse(localStorage.getItem("wishlist"));
    //check if already exists  if not add it to the array        //let add = true;
    wishlistData.some(element => { if (element.wpdvi === product.wpdvi && element.wpdi === product.wpdi) { add = false } })
  }
  if (add) {
    wishlistData.push(product);
    localStorage.setItem('wishlist', JSON.stringify(wishlistData));
    target.style.display = 'none';
    target.parentNode.querySelector('.remove-wishlist').style.display = 'flex';
    if ((target.classList.contains('vt-product') || parentPage == 'product') && target.parentNode.querySelector('.wishlist-add-success-message')) {
      target.parentNode.querySelector('.wishlist-add-success-message').style.display = 'block';
    }
    guestLogic();
    sendData(wishlistData);
    updateCount();
    dispatchvtWishCustomEvent('eventVtAddToWishlist', {
      wpdi: product.wpdi,
      wpdvi: product.wpdvi,
      targetFrom: parentPage,
      targetParentProduct: target.classList.contains('vt-product')
    });
  }
}

//Add to wishlist 
function addToWishlist(element, parentPage) {
  let add = true;
  let addPending = true;
  let wAddButtons = document.querySelectorAll(element);
  wAddButtons.forEach(function (i) {
    i.addEventListener('click', function (e) {
      e.preventDefault();
      let target = e.currentTarget;
      let product = {
        wpdi: target.dataset.product,
        wpdvi: target.dataset.variant,
        wpdurl: target.dataset.productUrl,
        source: window.location.pathname
      }
      // checking if product id and varioant id are there.
      if(product.wpdi !== ''){
        
        // if login is required. Guest user not allowed
        if (window.vtWishlist.generalSettings.is_login_required) {
          let loginRequiredMsgElement = target.parentNode.querySelector('.login-message');
          if (typeof vtnCustomerId === 'undefined' || vtnCustomerId === '' || vtnCustomerId === null) {
            let wishlistPendingData;

            if (localStorage.getItem("wishlist_pending") === null) {
              wishlistPendingData = [];
            } else {
              wishlistPendingData = JSON.parse(localStorage.getItem("wishlist_pending"));
              wishlistPendingData.some(element => { if (element.wpdvi === product.wpdvi) { addPending = false } })
            }
            if (addPending) {
              wishlistPendingData.push(product);
              localStorage.setItem('wishlist_pending', JSON.stringify(wishlistPendingData));
            }

            if (loginRequiredMsgElement && loginRequiredMsgElement.textContent !== '' && parentPage == 'product') {
              loginRequiredMsgElement.style.display = 'block';
              localStorage.setItem('wishlist_return', window.location.href);
              setTimeout(() => {
                loginRequiredMsgElement.style.display = 'none';
              }, 30000);
            }
            if (parentPage == 'collection' && target.parentNode.tagName == 'WISHLIST-COLLECTION-BUTTON') {
              localStorage.setItem('wishlist_return', window.location.href);
              window.location.href = '/account/login'
            }
          } else {
            addToWishlistCommon(target, product, add, parentPage);
          }
        } else {
          addToWishlistCommon(target, product, add, parentPage);
        }
        if(product.wpdvi === ''){
          let localData;
          if(localStorage.getItem("wishlist_pending") !== null){
            localData = localStorage.getItem("wishlist_pending");
          }else{
            localData = localStorage.getItem("wishlist");
          }
          
          let dataArray = JSON.parse(localData);
          let note = "Variant Id missing"
          logErrors(dataArray, note);
        }
      }else{
        let localData;
        if(localStorage.getItem("wishlist_pending") !== null){
          localData = localStorage.getItem("wishlist_pending");
        }else{
          localData = localStorage.getItem("wishlist");
        }
        
        let dataArray = JSON.parse(localData);
        dataArray.push(product);
        let note = "Product Id missing"
        logErrors(dataArray, note);
      }
    });
  });
}

const displayEmptyWishlistMessage = (ContainerElement) => {
  const PageScript = document.getElementById('wishlistpagescript');
  if (PageScript) {
    let emptyHeading = JSON.parse(PageScript.textContent).emptyWishlistHeading;
    let emptyWishlistCtaText = JSON.parse(PageScript.textContent).emptyWishlistCtaText;
    let emptyWishlistCtaLink = JSON.parse(PageScript.textContent).emptyWishlistCtaLink;
    let emptyWishlistCta = `<a href="${emptyWishlistCtaLink}">${emptyWishlistCtaText}</a>`;
    ContainerElement.innerHTML = `<h3>${emptyHeading}</h3>
        <p>${emptyWishlistCta}</p>`;
  }
};

//custom global remove from wishlist
window.vtRemoveFromWishlistTrigger = vtRemoveFromWishlist;
function vtRemoveFromWishlist(product, parentPage){
  let wishlistData = JSON.parse(localStorage.getItem("wishlist"));
  let newWishlistData = wishlistData.filter((item) => item.wpdvi !== product.wpdvi);
  localStorage.setItem('wishlist', JSON.stringify(newWishlistData));
  sendData(newWishlistData);
  updateCount();
  dispatchvtWishCustomEvent('vtWishlistRemovefromWishlist', {
    wpdi: product.wpdi,
    wpdvi: product.wpdvi,
    targetFrom: 'custom'
  });
}

// Remove From Wishlist
function removeFromWishlist(parentPage) {
  let removebuttons = document.querySelectorAll('.remove-wishlist');
  removebuttons.forEach(function (i) {
    i.addEventListener('click', function (e) {
      e.preventDefault();
      // console.log('remove clicked');
      let target = e.currentTarget;
      let product = {
        wpdi: target.dataset.product,
        wpdvi: target.dataset.variant,
        wpdurl: target.dataset.productUrl,
        source: window.location.pathname
      }
      let wishlistData = JSON.parse(localStorage.getItem("wishlist"));
      let newWishlistData = wishlistData.filter((item) => item.wpdvi !== product.wpdvi);
      localStorage.setItem('wishlist', JSON.stringify(newWishlistData));
      sendData(newWishlistData);
      updateCount();
      if (parentPage == 'wishlistpage') {
        target.closest('w-product-card').remove();
        let wishlistContainerElement = document.querySelector('.wishlist-display');
        if (document.getElementsByTagName('W-PRODUCT-CARD').length == 0 && wishlistContainerElement) {
          displayEmptyWishlistMessage(wishlistContainerElement);
        }
      } else {
        target.style.display = 'none';
        target.parentNode.querySelector('.add-wishlist').style.display = 'flex';
        if (parentPage == 'product' && target.parentNode.querySelector('.wishlist-add-success-message')) {
          target.parentNode.querySelector('.wishlist-add-success-message').style.display = 'none';
        }
      }
      dispatchvtWishCustomEvent('vtWishlistRemovefromWishlist', {
        wpdi: product.wpdi,
        wpdvi: product.wpdvi
      });
    });
  });
}

//for PDP and PLP QuickView //
  //check onload if the product/variant is already in wishlist or not
  window.vtWishlistChecker = wishlistchecker;
  function wishlistchecker(wpdi, wpdvi, wpdurl) {
    let wAddButton = document.querySelector('.vt-product-page .add-wishlist');
    let wRemoveButton = document.querySelector('.vt-product-page .remove-wishlist');
    if (localStorage.getItem("wishlist") !== null) {
      let wishlistData = JSON.parse(localStorage.getItem("wishlist"));
      let currentvariant = {
        wpdi: wpdi,
        wpdvi: wpdvi,
        wpdurl: wpdurl
      }

      wishlistData.some(element => {
        if (element.wpdvi === currentvariant.wpdvi) {
          wAddButton.style.display = 'none';
          wRemoveButton.style.display = 'flex';
        }
      })
    }
  }

  // function to listen and update changes
  window.onSelectorChange = onVariantChange;
  function onVariantChange(wVariantSelector) {
    let variantValue = wVariantSelector.value;
    let wAddButton = document.querySelector('.vt-product-page .add-wishlist');
    let wRemoveButton = document.querySelector('.vt-product-page .remove-wishlist');
    if (wVariantSelector.value !== '') {
      wAddButton.setAttribute("data-variant", wVariantSelector.value);
      wRemoveButton.setAttribute("data-variant", wVariantSelector.value);
    } else {
      let selectedVariantId = wAddButton.parentNode.getAttribute('data-first-variant');
      wAddButton.setAttribute("data-variant", selectedVariantId);
      wRemoveButton.setAttribute("data-variant", selectedVariantId);
      variantValue = selectedVariantId;
    }

    wRemoveButton.style.display = 'none';
    wAddButton.style.display = 'flex';
    wishlistchecker(wAddButton.getAttribute("data-product"), variantValue, wAddButton.getAttribute("data-product-url"));
    if (wAddButton.parentNode.querySelector('.wishlist-add-success-message')) {
      wAddButton.parentNode.querySelector('.wishlist-add-success-message').style.display = 'none';
    }
  }

  // listening to variant change and update the wishlist attributes
  window.vtVariantChange = variantChange;
  function variantChange(wVariantCheckElement){
    wVariantCheckElement.addEventListener('change', function (event) {
      onVariantChange(wVariantCheckElement)
    });
  }

//end for PDP and PLP QuickView //

//compare 2 arrays
function arraysAreEqual(array1, array2) {
  if (array1.length !== array2.length) {
    return false;
  }

  for (let i = 0; i < array1.length; i++) {
    const obj1 = array1[i];
    const obj2 = array2[i];

    // Compare each property of the objects
    for (const key in obj1) {
      if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }
    }
  }

  return true;
}

// listen tracking events Add to Cart, Add to Wishlist and Remove From Wishlist 
document.addEventListener('vtWishlistAddtoCart', function (event) {
  //  console.log('Add to Cart triggered with variant Id:', event.detail);
});
document.addEventListener('eventVtAddToWishlist', function (event) {
 // console.log('Add to Wishlist triggered with variant Id:', event.detail);
});
document.addEventListener('vtWishlistRemovefromWishlist', function (event) {
  //  console.log('Remove from Wishlist triggered with variant Id:', event.detail);
});